export default __webpack_public_path__ + "static/together-wealth-855f114de8617ea39132f9c92d7070be.svg";